// extracted by mini-css-extract-plugin
export default {"plProfit":"styles_plProfit__OM9Ii","betWon":"styles_betWon__8OoKN","betLost":"styles_betLost__HfFpZ"};